"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPatrimoineRevenusGroupsTrads = void 0;
exports.EPatrimoineRevenusGroupsTrads = {
    beneficieConventionsFiscales: "Avez-vous droit aux avantages des accords fiscaux qui permettent d’éviter une double imposition de vos revenus ?",
    nbEnfantsACharge: "Nombre d'enfants",
    montantImpotAnneePrecedente: "Montant de l'impôt N-1",
    trancheMarginaleImposition: "Tranche marginale d'imposition",
    montantIFIAnneePrecedente: "Montant de l'IFI N-1",
    situationPatrimoniale: "Situation patrimoniale",
    patrimoine: "Patrimoine",
    compositionPatrimoine: "Composition du patrimoine",
    originePatrimoine: "Origine du patrimoine",
    revenusAnnuelsBrutsFoyer: "Revenus annuels bruts du foyer",
    compositionRevenus: "Composition du revenu",
    capaciteEpargneMensuelle: "Votre situation vous permet d'épargner quelle somme tous les mois ?",
    investissementPatrimoineGlobal: "Part de cet investissement dans votre patrimoine global",
    montantGlobalPretRembourser: "En cas de prêt immobilier, montant global du prêt à rembourser ",
    revenuCharge: "Charges mensuelles",
    tauxEndettement: "En cas d'emprunt/dettes en cours, quel est votre taux d'endettement",
    chargesAnnuellesFoyerFiscal: "Charges annuelles du foyer fiscal",
    creditConsommation: "Crédit à la consommation (mensuel)",
    creditImmobilierInvestissementLocatif: "Crédit immobilier pour un investissement locatif (mensuel)",
    loyerOuCreditMensuel: "Loyer ou crédit mensuel",
};
